import {Component, OnInit, ViewChild, Input, QueryList} from '@angular/core';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {ProcedureSixService} from '../../services/procedures/procedure-six.service';
import {CoursesService} from '../../services/courses.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {LocalDataSource} from 'ng2-smart-table';
import {FilesService} from '../../services/files.service';
const moment = require('moment');
moment.locale('es');

@Component({
  selector: 'ngx-procedure-six',
  templateUrl: './procedure-six.component.html',
  styleUrls: ['./procedure-six.component.scss'],
})
export class ProcedureSixComponent implements OnInit {
  @Input() stationId: string;
  @ViewChild('signature', {static: false}) signaturePads: QueryList<SignaturePad>;
  signaturePadOptions: Object;
  state = 'Actividades';
  token = '';
  documents = {
    capacitacion: '',
  };


  attrAux = {
    loading: false,
    courses: {},
  };

  settingsEmployee = {
    actions: false,
    pager: {
      perPage: 10,
    },
    columns: {
      nns: {
        title: 'Número de trabajador',
        filter: true,
      },
      name: {
        title: 'Nombre',
        filter: true,
      },
      role: {
        title: 'Puesto',
        filter: true,
      },
      url: {
        title: 'Descargar',
        type: 'html',
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };

  settingsHistory = {
    actions: false,
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      date: {
        title: 'Fecha programada',
        filter: true,
      },
      staff: {
        title: 'Roles',
        filter: true,
      },
      download: {
        title: 'Lista de asistencia',
        type: 'html',
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };
  downloading = false;

  source: LocalDataSource = new LocalDataSource;

  constructor(
    private procedureSixService: ProcedureSixService,
    private coursesService: CoursesService,
    private fileService: FilesService,
  ) {
  }

  async ngOnInit() {
    await this.getCourses();
    await this.getCoursesByStation();
    this.generateDocument();
  }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  clearSignature(signaturePad) {
    signaturePad.clear();
  }

  async getCourses() {
    this.attrAux.loading = true;
    const [err, courses] = await this.coursesService.getCourses();
    this.attrAux.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error');
    this.attrAux.courses = courses.data;
    await this.generateInputSignature();
  }

  async getCoursesByStation() {
    this.attrAux.loading = true;
    const [error, result] = await this.procedureSixService.getScheduledCourse(this.stationId);
    this.attrAux.loading = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error');
    await this.source.load(await this.formatDataTableHistory(result.data));
  }

  async formatDataTableHistory (data: any) {
    const dataTable = [];
    for (const courseId in data) await dataTable.push({
        name: data[courseId].name,
        date: await moment(data[courseId].setDate).format('LL'),
        staff: data[courseId].staff.join(', '),
        download: '<img class="hover-cursor-pointer" src="assets/images/icons/download.png" width="25px">',
        downloadUrl: await this.generateUrlAttendance(courseId),
      });
    return dataTable;
  }

  async generateUrlAttendance (id: any) {
    return `${environment.baseEndpoint}/filesGeneratorv2/implementation/six/attendance/${id}/${this.stationId}`;
  }

  onUserRowSelect(event) {
    this.downloadFile(event.data.downloadUrl, event.data.name);
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }

  async generateInputSignature () {
    const width = document.documentElement.clientWidth * .36;
    for (const course in this.attrAux.courses) this.attrAux.courses[course].signature = {
      maxWidth: 1,
      'minWidth': 0.8,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  async scheduleCourse(course: any, signature: any) {
    this.attrAux.loading = true;
    this.attrAux.courses[course].signature = signature.toDataURL();
    this.attrAux.courses[course].key = course;
    const [error] = await this.procedureSixService.scheduleCourse(this.stationId, this.attrAux.courses[course]);
    this.attrAux.loading = false;
    if (error) {
      if (error.status === 409) return this.alert('Curso ya programado. Intente con otra fecha', 'error');
      return this.alert('Oops, intenta más tarde', 'error');
    }
    await this.getCoursesByStation();
    await this.alert('Curso programado con éxito');
  }

  async generateDocument() {
    this.documents.capacitacion = `${environment.baseEndpoint}/filesGeneratorv2/implementation/six/step/one/${this.stationId}`;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
